import { Brain, EyeOff, Handshake, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { RadarChart } from "@/components/RadarChart";
import { Eyebrow } from "@/components/istituti/Eyebrow";

const POINTS = [
  { id: "esperti", Icon: Brain, lead: "Sviluppato da esperti:", text: "redatto da psicologi, fotografa le soft skills senza esprimere voti." },
  { id: "anonimo", Icon: EyeOff, lead: "Grafico anonimo:", text: "l'algoritmo crea una mappa visiva accessibile alle aziende partner in totale anonimato." },
  { id: "etico", Icon: Handshake, lead: "Matchmaking etico e volontario:", text: "lo studente decide in totale autonomia se accettare un colloquio conoscitivo." },
];

const ISTITUTI_TRAITS = [
  { label: "Leader", value: 0.8 },
  { label: "Analitico", value: 0.45 },
  { label: "Creativo", value: 0.55 },
  { label: "Collaborativo", value: 0.9 },
  { label: "Organizzato", value: 0.65 },
  { label: "Comunicativo", value: 0.4 },
];

const ChartFrame = () => (
  <div className="glass rounded-[28px] p-4 sm:p-6" data-testid="istituti-chart-frame">
    <RadarChart traits={ISTITUTI_TRAITS} separator="•" />
  </div>
);

export const Bussola = () => (
  <section className="relative px-6 py-20 lg:py-36" data-testid="istituti-bussola-section">
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-center">
      <Reveal>
        <ChartFrame />
      </Reveal>
      <Reveal delay={150}>
        <Eyebrow className="mb-6">La Bussola per il Futuro</Eyebrow>
        <h2 className="font-extrabold tracking-[-0.04em] leading-[1.05] text-3xl sm:text-4xl lg:text-5xl max-w-[22ch]">
          Il test psico-attitudinale: <span className="text-titanium">una bussola per i tuoi diplomandi.</span>
        </h2>
        <ul className="mt-12 space-y-8 max-w-[60ch]">
          {POINTS.map(({ id, Icon, lead, text }) => (
            <li key={id} className="flex gap-5" data-testid={`bussola-point-${id}`}>
              <span className="mt-0.5 h-10 w-10 shrink-0 rounded-xl border border-[#1e2024] flex items-center justify-center">
                <Icon className="h-[18px] w-[18px] text-cyan" strokeWidth={1.5} />
              </span>
              <p className="text-base sm:text-lg leading-relaxed text-titanium">
                <strong className="font-semibold text-white">{lead}</strong> {text}
              </p>
            </li>
          ))}
        </ul>
        <div className="mt-12 inline-flex items-center gap-3 rounded-full border border-[#1e2024] px-4 py-2.5" data-testid="bussola-gdpr-note">
          <ShieldCheck className="h-4 w-4 text-cyan" strokeWidth={1.6} />
          <span className="text-[10px] font-semibold tracking-[0.2em] text-titanium border-r border-[#2a2d33] pr-3">GDPR</span>
          <span className="text-xs sm:text-sm text-titanium">Nessun dato venduto a terzi. Ritenzione massima 36 mesi.</span>
        </div>
      </Reveal>
    </div>
  </section>
);
